import { IconArrowLeft, IconArrowRight, useDirection } from '@adc/parallax-component-library';

const TopHeaderBackArrow = ({ testID }: { testID?: string }) => {
  return useDirection() === 'ltr' ? (
    <IconArrowLeft color="$neutral.100" testID={testID} />
  ) : (
    <IconArrowRight color="$neutral.100" testID={testID} />
  );
};

export { TopHeaderBackArrow };
